var Aneox;
(function(Aneox) {
    'use strict';

    var App = (function() {

        var self;

        var isTouchDevice;

        var currentLocale;
        var currentNode;
        var currentController;

        function App(fonts, locale, router, analytics, homeController, legalController) {
            self = this;

            self.fonts = fonts;
            self.locale = locale;
            self.router = router;
            self.analytics = analytics;
            self.controllers = {
                home: homeController,
                legal: legalController
            };

           var md = new MobileDetect(window.navigator.userAgent);
            Aneox.Data.Config.runtime = {
                isTouchDevice: 'ontouchstart' in document.documentElement,
                mobile: md.mobile(),
                supportsScrollEvents: !md.mobile() || (md.is('iOS') && md.is('Safari') && md.version('Safari') > 8)
            };

            lazySizesConfig.preloadAfterLoad = true;

            self.router.bind('pageChange', function(path, node, nodeLocale) {
                self.locale.setLocale(nodeLocale.locale);
                if (_.get(currentNode, 'id') === node.id) return;

                var rootNodeId, controllerId;

                // Enter/Leave animations
                if (_.get(currentNode, 'id') !== node.id) {
                    switch (_.get(currentNode, 'type')) {
                        case 'basic-page':
                            self.controllers[currentNode.id].leave();
                            break;
                        
                    }

                    switch (node.type) {
                        
                        default:
                            self.controllers[node.id].enter();
                            rootNodeId = node.id;
                            controllerId = node.id;
                            break;
                    }
                    
                }


                
                currentNode = node;
                currentController = self.controllers[controllerId];
            });

            self.locale.bind('localeChange', function(locale) {
                if (currentLocale === locale) return;

                // Update active language menu item
                $('.langue a').removeClass('active');
                $('.langue a[router-locale="' + locale + '"]').addClass('active');

                currentLocale = locale;

                setTimeout(handleWindowResize);
            });         

            // Window resize handling
            var handleWindowResize = function() {
                var windowHeight = $(window).height();

                
                _.forEach($('[screen-height]'), function(element) {
                    var heightElement = $(element);
                    var topMargin = _.parseInt(heightElement.css('margin-top'));
                    var bottomMargin = _.parseInt(heightElement.css('margin-top'));
                    var height = windowHeight - topMargin - bottomMargin;

                    if($(window).width() < 768){
                        heightElement.innerHeight(height / 2);
                    }else{
                        heightElement.innerHeight(height);
                    }
                    
                    
                });

                if (currentController && currentController.handleWindowResize) currentController.handleWindowResize.call(currentController);
            };

            var throttledWindowResizeHandler = _.throttle(handleWindowResize, 500, { leading: false, trailing: true });
            $(window).resize(throttledWindowResizeHandler);
            Visibility.change(throttledWindowResizeHandler);
            self.fonts.bind('fontsActive', handleWindowResize);
            handleWindowResize();

            // Scroll handling
            $(window).on('scroll', function (event) {
                
            });

            // Wheel handling
            $(window).on('mousewheel', function (event) {

            });

            // Touch handling
            if (Aneox.Data.Config.runtime.isTouchDevice) {
                var mc = new Hammer.Manager(document.body);
                mc.add(new Hammer.Swipe({ direction: Hammer.DIRECTION_HORIZONTAL }));
                mc.on('swipeleft swiperight', function (event) {
                });
            }

            // Keyboard handling
            $(window).keydown(function (event) {
            });

            if (Cookies.get('splashscreen') !== 'true') {
                var now = new Date();
                now.setFullYear(now.getFullYear() - 18);
                var nowText = now.toISOString().substring(0, 10).split('-');
                $('#splashscreen .date').text(nowText[2] + '/' + nowText[1] + '/' + nowText[0]);
                TweenMax.set('body', { overflow: 'hidden' })
                TweenMax.set('#splashscreen', { display: 'flex', opacity: 1 });
                TweenMax.fromTo('#splashscreen > .centered-wrapper', 0.5, { opacity: 0 }, { opacity: 1 });
            }

            // Detect browser language
            setTimeout(function() {
                var language = (navigator.language || navigator.userLanguage).slice(0, 2);
                if (_.includes(Aneox.Data.Config.locales, language)) {
                    //self.locale.setLocale(language);
                    self.router.setPath('/'+language);
                } else {
                    self.router.setPath('/en');
                    //self.locale.setLocale('en');
                }
                
                //self.router.reparseAnchors();
                
            }, 0);
        };

        App.prototype.acceptSplash = function(result) {
            if (!result) {
                window.history.back();
            } else {
                Cookies.set('splashscreen', 'true');
                TweenMax.set('body', { overflow: 'auto' });
                TweenMax.to('#splashscreen', 0.5, { opacity: 0, display: 'none' });
            }
        }

        return App;
    })();

    Aneox.App = App;
})(Aneox || (Aneox = {}));